import moment from 'moment'
import { Options } from './types'

export const options: Options[] = [
	'Last 7 days',
	'Last 30 days',
	'Last 90 days',
	'This week',
	'Last week',
	'This month',
	'Last month',
	'Custom'
]
export const ranges = {
	'Last 90 days': {
		startDate: moment().startOf('day').subtract(90, 'days').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	},
	'Last 30 days': {
		startDate: moment().startOf('day').subtract(30, 'days').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	},
	'Last 7 days': {
		startDate: moment().startOf('day').subtract(7, 'days').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	},
	'This month': {
		startDate: moment().startOf('month').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	},
	'This week': {
		startDate: moment().startOf('week').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	},
	'Last week': {
		startDate: moment().subtract(1, 'week').startOf('week').toDate(),
		endDate: moment().subtract(1, 'week').endOf('week').toDate(),
		key: 'selection'
	},
	'Last month': {
		startDate: moment().subtract(1, 'month').startOf('month').toDate(),
		endDate: moment().subtract(1, 'month').endOf('month').toDate(),
		key: 'selection'
	},
	Custom: {
		startDate: moment().subtract(30, 'days').toDate(),
		endDate: moment().endOf('day').toDate(),
		key: 'selection'
	}
}
